module.exports = __webpack_public_path__ + "img/mypage-active.5b1f0360.png";